import { useRef, type FC, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import { Swiper as SwiperType } from 'swiper'

import { speakersData } from 'resources'
import { SectionLayout } from 'components'
import { useResponsive, useVersion } from 'hooks'
import { ReactComponent as ArrowIcon } from 'assets/svg/arrow.svg'

import styles from './Speakers.module.scss'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import TeamCard from '../Team/TeamCard'

type SpeakersProps = {
  addToRefs?: (el: HTMLDivElement) => void
}

const Speakers: FC<SpeakersProps> = ({ addToRefs }) => {
  const swiperRef = useRef()
  const { version } = useVersion()
  const { isLaptop, isMobileM } = useResponsive()

  const [currentIndex, setCurrentIndex] = useState<number>(0)

  const slidesPerView = !isLaptop ? 4 : isMobileM ? 1 : 2
  const speakersListData = speakersData[version as keyof typeof speakersData]

  const updateIndex = (swiperInstance: SwiperType) => {
    if (swiperInstance === null) return
    const currentSlide = swiperInstance?.activeIndex
    setCurrentIndex(currentSlide)
  }

  const renderSpeakersList = speakersListData.map(data => (
    <SwiperSlide key={data?.id}>
      <TeamCard data={data as any} isSpeakers />
    </SwiperSlide>
  ))

  const pagination = {
    clickable: true,
    renderBullet: function (_: number, className: string) {
      return `<span disabled class="${className}"> </span>`
    },
  }

  return (
    <SectionLayout addToRefs={addToRefs} id='SPEAKERS' className={styles.wrapper}>
      <h2 className={styles.wrapper__title}>Speakers</h2>
      <div className={styles.container}>
        <div className='container speakerSlider'>
          <Swiper
            loop={isLaptop}
            initialSlide={currentIndex}
            onRealIndexChange={updateIndex}
            onBeforeInit={(swiper: any) => {
              swiperRef.current = swiper as any
            }}
            pagination={pagination}
            modules={[Autoplay, Pagination, Navigation]}
            spaceBetween={28}
            slidesPerView={slidesPerView}
          >
            {renderSpeakersList}
            <button
              disabled={!currentIndex}
              className='swaper--prev'
              onClick={() => {
                if (currentIndex < 4) {
                  ;(swiperRef.current as any)?.slideTo(0)
                } else {
                  ;(swiperRef.current as any)?.slideTo(currentIndex - 4)
                }
              }}
            >
              <ArrowIcon />
            </button>
            <button
              disabled={currentIndex === speakersListData.length - slidesPerView}
              className='swaper--next'
              onClick={() => (swiperRef.current as any)?.slideTo(currentIndex + 4)}
            >
              <ArrowIcon />
            </button>
          </Swiper>
        </div>
      </div>
    </SectionLayout>
  )
}

export default Speakers
